let env = process.env.NODE_ENV

const feathersAPI = env === 'production' ? 'https://dev.jamapp.de' : 'http://localhost:3030'

console.log('api: ' + feathersAPI)

export default feathersAPI 
  